import type { TrabajosConfig } from '@/api/installation.api';

/**
 * Lo que la pestaña Trabajos manda al guardar. PURO.
 *
 * El servidor acepta cada catálogo como opcional y, si falta, lo completa con el
 * default VACÍO: un catálogo olvidado acá se borraría en silencio al guardar
 * cualquier otra pestaña. Por eso vive en su propio archivo, con su test.
 *
 * Las filas a medio escribir (sin nombre) no viajan; el servidor aplica las
 * mismas reglas.
 */
export function trabajosParaGuardar(t: TrabajosConfig): TrabajosConfig {
  return {
    cierreConValidacion: t.cierreConValidacion,
    modelos: t.modelos
      .filter((m) => m.nombre.trim() !== '')
      .map((m) => ({
        id: m.id,
        nombre: m.nombre.trim(),
        mesesCobertura: Math.max(1, Math.floor(Number(m.mesesCobertura)) || 12),
      })),
    formasPago: t.formasPago
      .filter((f) => f.nombre.trim() !== '')
      .map((f) => ({ id: f.id, nombre: f.nombre.trim(), activa: f.activa })),
    nivelesResolucion: t.nivelesResolucion
      .filter((n) => n.nombre.trim() !== '')
      // Sin clave corta se usa el id, igual que el servidor: el trabajo nunca
      // queda apuntando a una cadena vacía.
      .map((n) => ({ id: n.id, codigo: n.codigo.trim() || n.id, nombre: n.nombre.trim(), activo: n.activo })),
    causasRaiz: t.causasRaiz
      .filter((c) => c.nombre.trim() !== '')
      .map((c) => ({ id: c.id, nombre: c.nombre.trim(), activo: c.activo })),
  };
}
